import { Space } from 'antd';
import { CheckCircleFilled, FileOutlined, WarningFilled } from '@ant-design/icons';
import { DeclarationDocumentType, DeclarationDocumentStatus } from 'store/jobs/types';

const statusColorMap: Record<DeclarationDocumentStatus, string> = {
    FINAL: 'var(--success-normal)',
    MISSING: 'var(--warning-normal)',
    DRAFT: 'var(--gray-2)',
};

const documentTypeLabelMap: Record<DeclarationDocumentType, string> = {
    SAD: 'SAD Document',
    CLEARANCE_SLIP: 'Clearance Slip',
    COMMERCIAL_INVOICE: 'Commercial Invoice',
};

type Props = {
    fileName?: string | null;
    documentType: DeclarationDocumentType;
    documentStatus: DeclarationDocumentStatus;
};

const DocumentItem = ({ fileName, documentType, documentStatus }: Props) => {
    if (documentStatus === 'DRAFT') return null;

    const statusColor = statusColorMap[documentStatus];
    const documentTypeLabel = documentTypeLabelMap[documentType];

    const isHighlighted = documentStatus === 'MISSING';
    const _fileName = isHighlighted ? '-' : fileName;

    return (
        <li style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
            <Space size={4}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {isHighlighted ? (
                        <WarningFilled style={{ color: statusColorMap.MISSING }} />
                    ) : (
                        <CheckCircleFilled style={{ color: statusColorMap.FINAL }} />
                    )}
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FileOutlined style={isHighlighted ? { color: statusColor } : undefined} />
                </div>
                <span style={isHighlighted ? { color: 'orange' } : undefined}>{_fileName}</span>
            </Space>
            <span style={isHighlighted ? { color: statusColor } : undefined}>{documentTypeLabel}</span>
        </li>
    );
};

export default DocumentItem;
